var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form-row', {
    attrs: {
      "title": _vm.title
    }
  }, [_c('div', {
    staticClass: "form-file-box"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "11"
    }
  }, [_c('v-file-input', {
    staticClass: "rounded-0",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: _vm.temp,
      callback: function callback($$v) {
        _vm.temp = $$v;
      },
      expression: "temp"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "1"
    }
  }, [_c('v-btn', {
    staticClass: "rounded-0",
    attrs: {
      "block": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.addFile
    }
  }, [_vm._v("첨부")])], 1)], 1), _c('v-chip-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.value, function (file, i) {
    return _c('v-chip', {
      key: i,
      staticClass: "rounded-0",
      attrs: {
        "value": file
      }
    }, [_c('span', [_vm._v(_vm._s(file.name))]), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-close")])], 1);
  }), 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }